import React from "react";
import Option from "./Option";
import "./FoodItem.css";

export default function OptionList({
  options,
  minSelection,
  maxSelection,
  addonId,
  foodItemQuantity,
  optionButtonId,
  selectedOptions,
  // onOptionToggle,
  onRadioOptionToggle,
  onCheckboxOptionToggle,
  onOptionQuantityChange,
  onSubOptionChange,
}) {
  return (
    <div className='option-list'>
     
      {options?.length > 0 && (
        <p className="thTitle" style={{ fontSize: '0.9rem', fontWeight: 500 }}>
          {minSelection > 0
            ? `Select min ${minSelection}-${maxSelection} option${maxSelection > 1 ? 's' : ''}`
            : `Select max ${maxSelection} option${maxSelection > 1 ? 's' : ''}`}
          {options.some(option => option.isOptionMustPick) && (
            <span className="text-danger"> *</span>
          )}
        </p>
      )}

      {options?.map((option) => (
        <Option
          key={option.optionId}
          addonId={addonId}
          option={option}
          foodItemQuantity={foodItemQuantity}
          optionButtonId={optionButtonId}
          selectedOption={selectedOptions?.[option.optionId]}
          // onOptionToggle={onOptionToggle}
          onRadioOptionToggle={onRadioOptionToggle}
          onCheckboxOptionToggle={onCheckboxOptionToggle}
          onOptionQuantityChange={onOptionQuantityChange}
          onSubOptionChange={onSubOptionChange}
        />
      ))}
    </div>
  );
}
